export default __webpack_public_path__ + "static/media/hrum.123745d6.mp3";